<div class="card flex-grid" [ngClass]="config.cardClass">
  <div class="card-data">
    <ng-container *ngFor="let field of config.fields">
      <div [innerHtml]="data | dataCellFormatter: field"></div>
    </ng-container>
  </div>
  <div class="card-controls">
    <ng-container *ngIf="config.controlType === 'checkbox'; else radio">
      <mat-checkbox class="example-margin" [value]="selected" (change)="toggleChange($event)"></mat-checkbox>
    </ng-container>
    <ng-template #radio>
      <mat-radio-button class="example-radio-button" [value]="data" (change)="onRadioSelect($event)">
      </mat-radio-button>
    </ng-template>
    <div *ngIf="config.isMiqSource" class="miq-label" l10nTranslate>shared.miq</div>
    <mat-icon *ngIf="!config.isMiqSource && config.icon">{{ config.icon }}</mat-icon>
  </div>
</div>
